import { memo } from "react";

// hero slider
import OttHeroSlider from "@/components/slider/OttHeroSlider";

// sections
import ContinueWatching from "@/components/sections/ContinueWatching";
import HomeFeedSection from "@/components/sections/HomeFeedSection";
import StyleCategoriesSection from "@/components/sections/StyleCategoriesSection";
import { homepageFilters } from '@/utils/video-queries';
import RecentVideos from "@/components/sections/RecentVideos";
import DebugComponent from "@/components/debug/SanityDebug";
import VerticalSectionSlider from "@/components/slider/VerticalSectionSlider";
import OnlyOnStreamit from "@/components/sections/OnlyOnStreamit";
import YourFavouritePersonality from "@/components/sections/YourFavouritePersonality";
import PopularMovies from "@/components/sections/PopularMovies";
import TabSlider from "@/components/sections/TabSlider";
import RecommendedForYou from "@/components/sections/RecommendedForYou";
import TopPicsForYou from "@/components/sections/TopPicsForYou";
import GenreSlider from "@/components/sections/GenreSlider";

import { ottVerticleLatestMovies } from "@/StaticData/data";

const OTT = memo(() => {

  return (
    <>
      <OttHeroSlider />
      {/* <ContinueWatching /> */}
      {/* New Releases */}
      <HomeFeedSection title="New Releases" filter={homepageFilters.newReleases} />

      {/* Cyclical */}
      <HomeFeedSection title="Cyclical" filter={homepageFilters.cyclical} />

      {/* Alice's Picks */}
      <HomeFeedSection title="Alice's Picks" filter={homepageFilters.alicesPicks} />

      {/* Series */}
      <HomeFeedSection title="Series" filter={homepageFilters.series} />

      {/* Instructor Inspo */}
      <HomeFeedSection title="Instructor Inspo" filter={homepageFilters.instructorInspo} />

      {/* Style Categories */}
      <StyleCategoriesSection />
      {/* <RecentVideos /> */}
      {/* <DebugComponent /> */}
      {/* <OnlyOnStreamit />
      <VerticalSectionSlider sliderData={ottVerticleLatestMovies} />
      <YourFavouritePersonality />
      <PopularMovies />
      <TabSlider />
      <GenreSlider />
      <RecommendedForYou />
      <TopPicsForYou /> */}
    </>
  );
});

OTT.displayName = "OTT";
export default OTT;
